import { Row, Col } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import { useAuthContext, removeAuthStorage } from "../../contexts/AuthContext";

const NavBar = () => {
  const { user, logOutAuthContext } = useAuthContext();

  return (
    <Row className="main-navbar sticky-top bg-white">
      <Col className="g-0">
        <Navbar expand="lg">
          <Container>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="justify-content-end">
              <Nav>
                <NavDropdown
                  title={user && user.name}
                  id="basic-nav-dropdown"
                  align="end"
                >
                  <NavDropdown.Item
                    onClick={() => {
                      removeAuthStorage();
                      logOutAuthContext();
                    }}
                  >
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </Col>
    </Row>
  );
};

export default NavBar;
